import { render, staticRenderFns } from "./OverworkDialogTable.vue?vue&type=template&id=d55da64c"
import script from "./OverworkDialogTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverworkDialogTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports